// extracted by mini-css-extract-plugin
export default {"nav-tab":"VerticalTab_nav-tab__lIkLM","nav-item":"VerticalTab_nav-item__ZGfUt","nav-link":"VerticalTab_nav-link__LKD1z","nav-link-content":"VerticalTab_nav-link-content__joitz"};